import { Paper, useTheme } from "@mui/material";
import { forwardRef } from "react";
import { getOrgTokens } from "../../theme/style/organizationPalette";

const StandardChartContainer = forwardRef(({ children, elevation = 1 }, ref) => {
  const theme = useTheme();
  const tok = getOrgTokens(theme.palette.mode === "dark");
  return (
    <Paper
      elevation={0}
      sx={{
        backgroundColor: tok.bg.card,
        border: `1px solid ${tok.border.card}`,
        borderRadius: tok.radius.card,
        boxShadow: tok.shadow.card,
        overflow: "hidden",
        height: "100%"
      }}
      ref={ref}
    >
      {children}
    </Paper>
  );
});
export default StandardChartContainer;
